<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import RadioButton from '../../components/RadioButton.vue';
import SolutoButton from '../../components/SolutoButton.vue';
import { mapActions, mapGetters } from 'vuex';
import { TranslateResult } from 'vue-i18n';

// this is Q13 in e-confluence page for call survey
export default defineComponent({
  name: 'SurveyQ71',
  components: {
    RadioButton,
    Button: SolutoButton
  },
  data () {
    return {
      call: [
        { text: this.$t('survey_071_checkbox_call0'), key: '0' },
        { text: this.$t('survey_071_checkbox_call1'), key: '1' },
        { text: this.$t('survey_071_checkbox_call2'), key: '2' },
        { text: this.$t('survey_071_checkbox_call3'), key: '3' },
        { text: this.$t('survey_071_checkbox_call4'), key: '4' },
        { text: this.$t('survey_071_checkbox_call5'), key: '5' },
        { text: this.$t('survey_071_checkbox_call6'), key: '6' },
        { text: this.$t('survey_071_checkbox_call7'), key: '7' }
      ],
      chat: [
        { text: this.$t('survey_071_checkbox_chat0'), key: '0' },
        { text: this.$t('survey_071_checkbox_chat1'), key: '1' },
        { text: this.$t('survey_071_checkbox_chat2'), key: '2' },
        { text: this.$t('survey_071_checkbox_chat3'), key: '3' },
        { text: this.$t('survey_071_checkbox_chat4'), key: '4' },
        { text: this.$t('survey_071_checkbox_chat5'), key: '5' },
        { text: this.$t('survey_071_checkbox_chat6'), key: '6' },
        { text: this.$t('survey_071_checkbox_chat7'), key: '7' },
        { text: this.$t('survey_071_checkbox_chat8'), key: '8' },
        { text: this.$t('survey_071_checkbox_chat9'), key: '9' },
        { text: this.$t('survey_071_checkbox_chat10'), key: '10' }
      ],
      data: [] as {text: TranslateResult; key: string}[]
    };
  },
  computed: {
    ...mapGetters([
      'supportUnhelpfulnessReason',
      'isCallSurvey'
    ])
  },
  created () {
    if (this.isCallSurvey) {
      this.data = this.call;
    } else {
      this.data = this.chat;
    }
  },
  methods: {
    ...mapActions([
      'changeSupportUnhelpfulnessReason'
    ]),
    change (event: number) {
      this.changeSupportUnhelpfulnessReason(this.data[event].text);
    },
    findValue () {
      const filteredData = this.data.filter(e => e.text === this.supportUnhelpfulnessReason);
      if (filteredData.length !== 0) {
        return filteredData[0].key;
      }
      return null;
    },
    nextScreen () {
      if (this.supportUnhelpfulnessReason === this.$t('other')) {
        // navigate user to Q72 which is Q14 in e-confluence page for call survey
        router.push({ path: '/survey/question72/' });
      } else {
      // navigate user to Q8 which is Q15 in e-confluence page for call survey
        router.push({ path: '/survey/question8/' });
      }
    },
    goBack () {
      router.go(-1);
    }
  }
});
</script>

<template>
  <div class="mainSurvey">
    <div>
      <p class="with-margin">{{ isCallSurvey ? $t('survey_071_01_call') : $t('survey_071_01') }}</p>
      <radio-button :text="data" @change="change($event)" :value="findValue()"/>
    </div>
    <div class="mainSurvey-footer">
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('previous')"
        :type="'outlined'"
        @click="goBack()"
      />
      <Button
        class="footer-button"
        :disabled="!supportUnhelpfulnessReason"
        :size="'large'"
        :text="$t('next')"
        @click="nextScreen()"
      />
    </div>
  </div>
</template>
